import base from '../dr-base'
import drChartCanvas from './dr-chart-canvas.vue'

const schema = {
  ...base,
  $Type: 'dr-chart-canvas',
  name: 'CanvasJS chart',
  group: 'Advanced',
  icon: 'chart-pie',
  properties: {
    ...base.properties,
    Chart: {
      name: 'vuetifyWidgets.dr-chart-canvas.chart',
      type: 'string'
    },
    Height: {
      name: 'vuetifyWidgets.dr-chart-canvas.height',
      type: 'string',
      default: '200px'
    }
  }
}

export default {
  schema,
  component: drChartCanvas
}
